import { z } from "zod";
import { TaskVisibility } from "./docs.js";
/**
 * `tasks.import` (architecture §10): action items from meeting notes kept outside KitWork+ (a
 * Granola note, say) become tasks in one call. Each item has a `key`, stable within its source,
 * so importing the same notes again skips the items already imported instead of duplicating them.
 */
export const TaskImportItem = z.object({
    /** Stable per item within the source, e.g. the item's position or a short slug of its text. */
    key: z.string().min(1).max(200),
    title: z.string().min(1).max(300),
    notes: z.string().max(10_000).optional(),
    due: z.date().nullable().optional(),
    /** A workspace member, by email or `@handle` (first name, full name, or email local part). */
    assignee: z.string().min(1).max(320).optional(),
    visibility: TaskVisibility.optional(),
});
export const TasksImportInput = z.object({
    workspaceId: z.string().min(1),
    /** Where the items came from: the meeting notes' URL or id. Shown on each task as its source. */
    source: z.object({ kind: z.literal("meeting"), ref: z.string().min(1).max(500) }),
    items: z.array(TaskImportItem).min(1).max(50),
});
export const TasksImportOutput = z.object({
    created: z.array(z.object({ key: z.string(), taskId: z.string(), title: z.string() })),
    /** Items imported before (same caller, source and key): left as they are. */
    skipped: z.array(z.object({ key: z.string(), taskId: z.string() })),
});
//# sourceMappingURL=tasks.js.map